const doc = [({"en":({"js":({"admin":({"election_posts":({"table":({"election_posts":"Election posts"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;